import React from 'react';

type TitleProps = {
    className?: string;
}

const Title: React.FC<TitleProps> = ({ className, children }): JSX.Element => (
    <h1 className={className ? `title ${className}` : 'title'}>
        { children }
    </h1>
);

export default Title;
